import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subscription } from 'rxjs';
import { CameraService } from 'src/app/services/camera/camera.service';
import { GatewayModalComponent } from 'src/app/shared/components/modals/gateway/gateway-modal.component';
import { MessageModalComponent } from 'src/app/shared/components/modals/message/message-modal.component';
import { ModalCameraCounterComponent } from 'src/app/shared/components/modals/modal-list-camera-counter/modal-camera-counter/modal-camera-counter.component';
import { ModalListCameraCounterComponent } from 'src/app/shared/components/modals/modal-list-camera-counter/modal-list-camera-counter.component';
import { AppConstants } from 'src/app/shared/constants/app.contants';
import { AlertService, MessageSeverity } from 'src/app/shared/services/alert.service';

@Component({
  selector: 'app-camera-counter',
  templateUrl: './camera-counter.component.html',
  styleUrls: ['./camera-counter.component.css']
})
export class CameraCounterComponent implements OnInit {

  loading: boolean = false;
  dataSource = new MatTableDataSource();
  displayedColumns: string[] = ['index','headquarter','camera','regions','action'];
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  isAdminGys: boolean = false;
  countMaxUserByEnterprise: number = 0;
  enterprises = [];
  headquarters = [];
  subscription: Subscription;
  enterpriseSelect: number = 0;
  headquarterSelect: number = 0;
  pageEvent: PageEvent;
  pageIndex: number = 0;
  pageSize: number = AppConstants.Paginado.DEFAULT_PAGE_SIZE_PAGINATION;
  length: number = 0;
  page: number = 1;
  color1: string;
  color2: string;
  colorFont: string;
  colorFont2: string;
  searchText: string = '';
  timer:any;
	timeoutVal = 800;
  enabledRead: number;
  enabledWrite: number;

  constructor(
    public dialog: MatDialog,
    private alertService: AlertService,
    private cameraService: CameraService,
    private router: Router,
    private spinner: NgxSpinnerService,
    ) {
      document.getElementById("titleHeaderNav").innerHTML = 'Video Analítica > <span class="font-weight-bold">Cámaras de Conteo</span>';
    }

  ngOnInit() {
    this.setLS();
    this.isAdminGys = (+localStorage.getItem(AppConstants.Session.ROLID) == AppConstants.UserRole.AdministradorGyS || +localStorage.getItem(AppConstants.Session.ROLID) == AppConstants.UserRole.UsuarioGyS) ? true : false;
    this.dataSource.paginator = this.paginator;
    this.paginator._intl.itemsPerPageLabel = '';
    this.enterpriseSelect = (+localStorage.getItem(AppConstants.Session.ENTERPRISE));
    this.headquarterSelect = (+localStorage.getItem(AppConstants.Session.HEADQUARTER));
    this.getList();
  }

  setLS(){
    this.color1 = localStorage.getItem(AppConstants.Session.THEME_COLOR1);
    this.color2 = localStorage.getItem(AppConstants.Session.THEME_COLOR2);
    this.colorFont = localStorage.getItem(AppConstants.Session.THEME_COLOR_FONT);
    this.colorFont2 = localStorage.getItem(AppConstants.Session.THEME_COLOR_FONT2);
    //validate Permisses menu
    var menu = JSON.parse(localStorage.getItem(AppConstants.Session.MENU));
    var page = this.router.url.split("/");
    var i = page[page.length-1];
    var itemTag = menu.filter(x => x.tag != null && (x.tag.toString()).toLowerCase().includes(i));
    if(itemTag.length>0){
      this.enabledRead = itemTag[0].activeRead;
      this.enabledWrite = itemTag[0].activeWrite;
    }else{
      this.enabledRead = 0;
      this.enabledWrite = 0;
    }
  }

  getList(){
    var filter = {
      Page: this.page,
      Rows: AppConstants.Paginado.DEFAULT_PAGE_SIZE_PAGINATION,
      IdEnterprise: this.enterpriseSelect,
      IdHeadquarter: this.headquarterSelect,
      Filter: this.searchText
    };
    this.spinner.show();
    this.cameraService.getListCameraCounter(filter).subscribe((_) => {
      if(_.error == null){
        this.dataSource = new MatTableDataSource(_["rows"]);
        this.pageIndex = +_["page"]-1;
        this.length = _["total"];
      }
      this.spinner.hide();
    });
  }

  getServerData(event?: PageEvent) {
    this.page = event.pageIndex + 1;
    this.getList();
  }

  openEditModal(data){
      let dialogRef = this.dialog.open(ModalListCameraCounterComponent, {
        data: {
          title: AppConstants.TitleModal.LIST_REGION_CAMERA_COUNTER_TITLE,
          action: AppConstants.OperationType.UPDATE,
          headquarters: this.headquarters,
          idHeadquarter: this.headquarterSelect,
          idEnterprise: this.enterpriseSelect,
          isAdminGys: this.isAdminGys,
          enabledWrite: this.enabledWrite,
          enabledRead: this.enabledRead,
          obj:data,
          color: this.color1,
          colorFont: this.color2
        },
        width: '500px',
        hasBackdrop: true
      });
      dialogRef.afterClosed().subscribe(_ => {
          this.getList();
      });
  }

  delete(obj) {
    let dialogRef = this.dialog.open(MessageModalComponent, {
      data: {
        title: AppConstants.TitleModal.DELETE_CONFIRMATION_TITLE,
        message: `${AppConstants.MessageModal.DELETE_DEFAULT}`,
        hasButton: true,
        contentButton: {
          yes: 'SI',
          no: 'CANCELAR'
        }
      },
      width: '600px',
    });

    dialogRef.afterClosed().subscribe(response => {
      if (response.result == true) {
        this.deleteSecurity(obj.id);
      }
    });

  }

    deleteSecurity(id: number) {
      this.spinner.show();
     /* this.gService.delete(id).subscribe((response => {
        this.spinner.hide();
        this.page = 1;
        this.paginator.pageIndex = 0;
        this.alertService.showMessage(AppConstants.TitleModal.DELETE_GATEWAY, AppConstants.MessageModal.DELETE, MessageSeverity.success);
        this.getList();
      }),
      (error: HttpErrorResponse) => {
        this.alertService.showMessage(AppConstants.TitleModal.DELETE_GATEWAY, error.error.messages, MessageSeverity.error);
        this.spinner.hide();
      });*/
    }

    applyUpFilter(event: Event) {
      const filterValue = (event.target as HTMLInputElement).value;
      this.searchText = filterValue.trim().toLowerCase();
        var _this = this;
        window.clearTimeout(_this.timer);
          _this.timer = window.setTimeout(() => {
              _this.page = 1;
              _this.paginator.pageIndex = 0;
              _this.getList();
            }, _this.timeoutVal);
    }

    applyPressFilter(event: Event) {
      var _this = this;
      window.clearTimeout(_this.timer);
    }
}

